import {
	Button,
	Elem,
	ElemBefore,
	SearchSelectOptionProps,
} from "@alm/flow-ds/components";
import BusinessLogicContext, {
	BusinessLogicContextProps,
} from "contexts/BusinessLogicContext";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { logicType } from "schemas/elements";
import Logic from "./Logic";
import { status } from "../../../../constants";
import api from "lib/api";
import axios from "axios";

export default () => {
	const { t } = useTranslation();

	const { action, handleUpdateStore, elementIndex, value, addAlert } =
		useContext(BusinessLogicContext) as BusinessLogicContextProps;

	const [sharedOptions, setSharedOptions] = useState<
		SearchSelectOptionProps[] | undefined
	>(undefined);
	const [unsharedOptions, setUnsharedOptions] = useState<
		SearchSelectOptionProps[] | undefined
	>(undefined);

	const [loading, setLoading] = useState(true);

	const newItem = useMemo(() => {
		return { name: "", shared: false, params: {} };
	}, []);

	const TENANT: string =
		window.location.hostname.substring(
			0,
			window.location.hostname.indexOf(".")
		) || "";

	const handleAdd = useCallback(() => {
		handleUpdateStore({
			...value,
			logic: [...value.logic, newItem],
		});
	}, [handleUpdateStore, newItem, value]);

	const getSharedList = useCallback(async () => {
		try {
			const shared = await api.businessLogic.getSharedNames();
			const unshared = await api.businessLogic.getUnsharedNames();
			setSharedOptions(shared);
			setUnsharedOptions(unshared);
		} catch (error) {
			if (error && axios.isAxiosError(error)) {
				if (error.response?.status === 504)
					addAlert("errorLoadingFormList", status.ERROR);
				console.error(`Error: ${error.message}`);
			}
		}
		setLoading(false);
	}, [addAlert]);

	useEffect(() => {
		getSharedList();
	}, [getSharedList]);

	return (
		<Elem className="elem-logic">
			<ElemBefore label={t("formDesigner.labels.logic")} />
			<div className="hint-text">
				{t(`formDesigner.elements.businessLogic.logic`)}
			</div>
			{value?.logic?.map((item: logicType, index: number) => {
				return (
					<Logic
						item={item}
						key={`${action}-${elementIndex}-logic-${index}`}
						index={index}
						nameOptions={[
							{
								label: t("formDesigner.labels.shared"),
								options: sharedOptions || [],
							},
							{ label: TENANT, options: unsharedOptions || [] },
						]}
						loading={loading}
					/>
				);
			})}
			<div className="elem-logic-add">
				<Button
					label={t("formDesigner.labels.addLogic")}
					onClick={handleAdd}
					className="btn-default"
				/>
			</div>
		</Elem>
	);
};
